import PropTypes from 'prop-types';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const StudyClassificationPreview = ({ value, defaultValue = null }) => {
  const { t } = useTranslation('common');
  return !value ? defaultValue : t(`studyClassifications.${value}`);
};

export default memo(StudyClassificationPreview);

StudyClassificationPreview.propTypes = {
  defaultValue: PropTypes.any,
  value: PropTypes.string
};
